import React from "react";
import { StaticQuery, graphql } from "gatsby";
import { useTranslation, Trans } from "react-i18next";
import cx from "classnames";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// import ZmtRoadmapLaunch from "./animations/zmt-roadmap-launch";
// import ZmtRoadmapQ1 from "./animations/zmt-roadmap-q1";
// import ZmtRoadmapQ2 from "./animations/zmt-roadmap-q2";

import ZmtRoadmapMobile from "./zmt-roadmap-mobile";

const ZmtRoadmap = (props) => {
  const { t } = useTranslation();
  const settings = {
    className: "timeline-slider center",
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    centerMode: true,
    swipeToSlide: true,
    focusOnSelect: true,
    dots: false,
    autoplay: false,
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
          focusOnSelect: true,
        },
      },
    ],
  };

  // const animations = (className = '') => [
  //   <ZmtRoadmapLaunch />,
  //   <ZmtRoadmapQ1 className={className}/>,
  //   null,
  //   <ZmtRoadmapQ2 className={className}/>,
  //   null,
  //   null,
  // ];

  return (
    <>
      <div id="zmt-roadmap">
        <ZmtRoadmapMobile
          iconPointer={props.iconPointer}
          iconPointer2={props.iconPointer2}
          iconPointer3={props.iconPointer3}
        ></ZmtRoadmapMobile>

        <div className="d-none d-md-block">
          <div
            className="text-center"
            data-sal="slide-up"
            data-sal-duration="400"
            data-sal-easing="ease-in-quad"
            data-sal-delay="100"
          >
            <h2>
              <Trans
                i18nKey="zmt.roadmap.title"
                components={[<span>Roadmap</span>]}
              />
            </h2>
          </div>
          <Slider {...settings} className="d-none d-md-block">
            {t("zmt.roadmap.road", { returnObjects: true }).map((road, i) => (
              <div className="card-roadmap">
                <div className="card-roadmap-inner">
                  {/* {animations()[i]} */}
                  <div className={cx("card-roadmap__line", `q${i}`)} />
                  <ul className="list-unstyled">
                    {road.maps.map((map, j) => (
                      <li
                        className={cx("media", {
                          "my-4": j > 0 && j < road.maps.length,
                        })}
                      >
                        <img
                          src={props.iconPointer.publicURL}
                          className="mr-3"
                          alt={map}
                        />
                        <div className="media-body">
                          <h5 className="mt-0 mb-1">{map}</h5>
                          {road.toBeDisclosed && j === road.maps.length - 1 && (
                            <>{road.toBeDisclosed}</>
                          )}
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="slider-single-line">
                  <img
                    className="img-fluid pointer-active"
                    src={props.lineActive.publicURL}
                    alt="Active Line"
                  />
                  <img
                    className="img-fluid pointer-inactive"
                    src={props.iconPointerAlt.publicURL}
                    alt="Pointer"
                  />
                </div>
                <div className="slider-single-date">
                  <span>{road.date}</span>
                </div>
              </div>
            ))}
            <div className="card-roadmap"></div>
          </Slider>
          <div className="container">
            <div className="row justify-content-center mt-3">
              <div className="drag-and-hold">
                <img
                  alt=""
                  src={props.whiteArrowLeft.publicURL}
                  className="white-arrow"
                />
                {t("zmt.roadmap.dragAndHold")}
                <img
                  alt=""
                  src={props.whiteArrowRight.publicURL}
                  className="white-arrow"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default () => (
  <StaticQuery
    query={graphql`
      query {
        iconPointer: file(relativePath: { eq: "images/icons/pointer.svg" }) {
          publicURL
        }
        iconPointer2: file(relativePath: { eq: "images/icons/pointer-2.svg" }) {
          publicURL
        }
        iconPointer3: file(relativePath: { eq: "images/icons/pointer-3.svg" }) {
          publicURL
        }
        whiteArrowLeft: file(
          relativePath: { eq: "images/icons/arrow-white-left.svg" }
        ) {
          publicURL
        }
        whiteArrowRight: file(
          relativePath: { eq: "images/icons/arrow-white-right.svg" }
        ) {
          publicURL
        }
        lineActive: file(relativePath: { eq: "images/line-active.svg" }) {
          publicURL
        }
        iconPointerAlt: file(
          relativePath: { eq: "images/icons/pointer-alt.svg" }
        ) {
          publicURL
        }
      }
    `}
    render={(data) => (
      <ZmtRoadmap
        iconPointer={data.iconPointer}
        lineActive={data.lineActive}
        iconPointerAlt={data.iconPointerAlt}
        iconPointer2={data.iconPointer2}
        iconPointer3={data.iconPointer3}
        whiteArrowLeft={data.whiteArrowLeft}
        whiteArrowRight={data.whiteArrowRight}
      />
    )}
  />
);
